/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable max-len */
import React from 'react';
import { connect } from 'react-redux';
import { closeModal, switchModal, speak } from '../../actions';
import X from '../../assets/login/x.svg';

const Onboarding2 = (props) => {
  return (
    <div className="modal onboarding-background onboarding-2">
      <img onClick={props.closeModal} className="x-icon" src={X} alt="x" />
      <h2 className="onboarding-header">
        Check this out!
      </h2>
      <div className="onboarding-main-container">
        <div className="onboarding-body">
          <div>
            <div className="onboarding-circle">2</div>
          </div>
          <div>
            <h4 className={`${props.speechEnabled && 'bolded'} color`} onClick={props.speak}>Understanding your result</h4>
            <div className="onboarding-text-container">
              <p onClick={props.speak} className={`${props.speechEnabled && 'bolded'} color`}>
                Your personalized results from your survey are presented in three sections: About the survey, Insights about you, and Tools recommended for you. Results are based on neuroscience, learning sciences, and best practices from the field.
              </p>
            </div>
          </div>
        </div>
        <div className="onboarding-nav">
          <p onClick={() => props.switchModal('Onboarding1')} className="skip">Back</p>
          <p onClick={() => props.switchModal('Onboarding3')} className="skip">Next</p>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => (
  {
    speechEnabled: state.speech.enabled,
  }
);

export default connect(mapStateToProps, { closeModal, switchModal, speak })(Onboarding2);
